import { PriceDetails } from '@ui/uikit/components/common/PriceDetails';
import { Typography } from '@ui/uikit/components/common/Typography';

import type { AdjacentRound } from '../../../../../../model/AdjacentRound/adjacentRound';
import { PredictionRoundState } from '../../../../../../model/AdjacentRound/roundState';
import { PredictionCountDown } from '../../../PredictionCountDown/PredictionCountDown';
import { PredictionCardButtons } from './PredictionCardButtons/PredictionCardButtons';
import { PredictionCardWrapper } from './PredictionCardWrapper/PredictionCardWrapper';
import { PredictionChip } from './PredictionChip/PredictionChip';
import { PredictionMainPrice } from './PredictionMainPrice/PredictionMainPrice';
import { PredictionOptions } from './PredictionOptions/PredictionOptions';
import { PredictionRoundProgressBar } from './PredictionRoundProgressBar/PredictionRoundProgressBar';

type PredictionCardsSectionProps = {
  round: AdjacentRound;
};

export const PredictionCard = ({ round }: PredictionCardsSectionProps) => {
  const isLocked = round.state === PredictionRoundState.LOCKED;
  const isActive = round.state === PredictionRoundState.ACTIVE;

  return (
    <PredictionCardWrapper isLocked={isLocked}>
      <div className="p-4 pt-3 w-full h-full flex flex-col gap-4">
        <div className="h-full flex flex-col gap-1.5">
          <PredictionRoundProgressBar round={round} />
          <div className="h-4 w-full flex">
            {(isLocked || isActive) && (
              <Typography color="tertiary" variant="caption-xs-strong" textAlign="left">
                {isActive ? 'Price locks in ' : 'Result in '}
                <PredictionCountDown value={round.closeTimestamp} />
              </Typography>
            )}
          </div>
          <div className="flex flex-col justify-between h-full gap-4">
            <div className="flex flex-col h-full justify-center">
              <div className="h-12 mb-4 flex items-center justify-center">
                <PredictionChip round={round} />
              </div>
              <PredictionMainPrice round={round} />
              <div>
                <Typography variant="caption-m" color="tertiary" textAlign="center">
                  {round.state === PredictionRoundState.ACTIVE
                    ? `Current Price: ${round.closePrice.formatted}`
                    : `Locked Price: ${round.lockPrice.formatted}`}
                </Typography>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div
                className={round.state === PredictionRoundState.ACTIVE ? 'invisible' : undefined}
              >
                <PriceDetails
                  items={[{ description: 'Prize Pool', value: round.totalAmount.formatted }]}
                />
              </div>
              <PredictionOptions round={round} />
            </div>
          </div>
        </div>
        <PredictionCardButtons round={round} />
      </div>
    </PredictionCardWrapper>
  );
};
